import { CookieCategoryBit } from '@tinkoff/statist-page-data';
import { DEFAULT_ID_STORAGE_DURATION } from './settings';
export var idCookies = {
    sessionId: {
        name: 'vIdUid',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
    wuid: {
        name: '__P__wuid',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
    webviewWuid: {
        name: 'deviceId',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
    // @deprecated не используется
    deviceId: {
        name: 'stDeIdU',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
    lastEventTime: {
        name: 'stLaEvTi',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
    sessionStartTime: {
        name: 'stSeStTi',
        category: CookieCategoryBit.Essential,
        expires: DEFAULT_ID_STORAGE_DURATION,
        subdomains: true,
    },
};
//# sourceMappingURL=cookieList.js.map